import DataType from '../../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import IHistoryData from '../../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';

export default class HistoryData implements IHistoryData {
    public readonly transactionID: string;
    public readonly roundID: number;
    public readonly gameID: string;
    public readonly bet: number;
    public readonly win: number;
    public readonly reserved: number;
    public readonly gameBet: number;
    public readonly gameWin: number;
    public readonly timestamp: number;
    public readonly machineID: number;
    public readonly machineName: string;
    public readonly date: Date;
    public readonly balance: number;
    public readonly describe: string;
    public readonly hallID: DataType.Enums.HallType;
    public readonly tableID: string;
    public readonly actualRoundID: number;
    public readonly replayable: boolean;
    public readonly gameType: DataType.Enums.PlayType;

    constructor(rawData: DataType.History.ResultData) {
        this.transactionID = rawData.ID;
        this.roundID = rawData.RoundID;
        this.gameID = rawData.GameID;
        this.bet = rawData.Bet ?? 0;
        this.win = rawData.Win ?? 0;
        this.reserved = rawData.Reserved ?? 0;
        this.gameBet = rawData.GameBet ?? 0;
        this.gameWin = rawData.GameWin ?? 0;

        this.date = new Date(rawData.Time);
        this.timestamp = this.date.getTime();

        this.machineID = rawData.ArcadesID ?? 0;
        this.gameType = (rawData.Extra as any).HallID === 1 ? DataType.Enums.PlayType.Single : (rawData.Extra as any).HallID;
        // this.machineName = TableGame.i18n?.getMessage(rawData.GameID.toUpperCase()) ?? 'Unknown Machine Name';
        // this.balance = rawData.Balance ?? 0;
        // this.describe = rawData.Describe ?? '';
        // this.hallID = rawData.HallID ?? rawData.Extra?.HallID ?? DataType.Enums.HallType.Normal;
        // this.tableID = (rawData.Extra?.TableID ?? rawData.TableID ?? '').toString();
        // this.actualRoundID = rawData.ActualRoundID ?? rawData.Extra?.RoundID ?? rawData.RoundID;
        // this.replayable = rawData.Replayable ?? false;
    }
}
